import { executeRequest, Request } from '@jfs/network'
import { JIO_PAYMENT_BANK_BIN } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { sendEventApi } from './sendEvent'

// On-Us expects an empty string for countryCode
export const COUNTRY_CODE_ON_US = ''
export const COUNTRY_CODE_OFF_US = '+91'
export const extraInfo = ''
// export const JIO_PAYMENT_BANK_BIN = '607884'

interface OtpOptions {
    mode?: number;
    purpose?: number;
    amount?: any;
    scope?: string;
    generate?: string;
    entityType?: number;
    consent?: string;
    aadhaarNo?: string;
    userId?: string;
    bankId?: string;
    consentCode?: string;
    vid?: string;
}

const getOtpRequestBody = (
    phoneNumber: string,
    options?: OtpOptions
) => {
    console.log("==> NETWORK LAYER: Received options configuration wrapper:", options);

    // Check if it's an On-Us transaction (either bankId is missing or explicitly matches Jio Bank BIN)
    const isJioBank = !options?.bankId || options?.bankId === JIO_PAYMENT_BANK_BIN;

    return {
        user: {
            mobile: {
                mobileNumber: phoneNumber,
                countryCode: isJioBank ? COUNTRY_CODE_ON_US : COUNTRY_CODE_OFF_US,
            },
            entityType: options?.entityType,
            ...(!isJioBank && {
                emailAddress: '',
                userId: options?.userId,
                bankDetails: {
                    bankId: options?.bankId
                }
            })
        },
        scope: isJioBank ? 'REQUEST' : (options?.scope ?? 'REQUEST'),
        authenticateList: [
            {
                mode: options?.mode,
                action: options?.generate,
                ...(options?.aadhaarNo ? {
                    aadhaar: {
                        number: options.aadhaarNo
                    }
                } : options?.vid ? {
                    aadhaar: {
                        virtualId: options.vid
                    }
                } : {}),
                consent: options?.consent ?? '',
                ...(!isJioBank && options?.consentCode && { consentCode: options.consentCode })
            },
        ],
        purpose: options?.purpose,
        ...(options?.amount !== undefined && { amount: Number(options.amount) }),
        extraInfo: extraInfo,
    }
}

const responseParser = (data: any) => {
    return data
}

const generateCWOTP = (
    mobileNumber: string,
    tokens: any,
    options?: OtpOptions
) => {
    const request: Request<{}> = {
        apiPath: APIEndPoints.userAuth,
        method: 'POST',
        config: sitConfig(tokens),
        body: getOtpRequestBody(mobileNumber, options),
    }

    sendEventApi(tokens, request, {
        status: 'INITIATED',
    })

    return executeRequest(request)
        .then((data) => {
            return responseParser(data.data)
        })
        .then((response) => {
            sendEventApi(tokens, request, {
                status: 'SUCCESS',
            })
            return response
        })
        .catch((err) => {
            sendEventApi(tokens, request, {
                status: 'FAILED',
                errorDescription: err,
            })
            throw err
        })
}

export { generateCWOTP }

